import { createInterception } from "../utils/script-defer"
import { mediaQuery } from "../utils/media-query"
import { $Q } from "graditify-utils"

/**
 * Set src
 * @param {node} element - element to search data-src and insert src
 * @returns null - stop called
 */
const insertSource = (element) => {
  if (!element && element.hasAttribute('data-src')) return

  element.src = element.dataset.src
}

/**
 * Load defer iframe src
 * @returns null - stop called
 */
export const cloudinaryIframDefer = () => {
  const iframe = $Q('.js-hero-vide-defer')

  if (!iframe) return

  createInterception(iframe, () => {
    mediaQuery('(min-width: 768px)', () => insertSource($Q('.js-hero-video-desk')))
    mediaQuery('(max-width: 767px)', () => insertSource($Q('.js-hero-video-mobile')))
  })
}
